import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { "@mui/material/styles": { styled }, "@mui/material/Box": Box, "@mui/material/Card": Card, "@mui/material/CardContent": CardContent, "@mui/material/Chip": Chip, "@mui/material/Typography": Typography } } });
export default ClientProvider;
